import { Maybe } from '@codegrade/maybe';
import { datetime, expr } from '@codegrade/utils';
/**
 * Checks if a refund if allowed or not.
 *
 * @param transaction An instance of a user transaction.
 * @param getNow The time (a moment) at which the transaction is done.
 * @returns The time of the successful transaction the remaining regund time.
 */
export function canBeRefunded(transaction, getNow) {
    if (transaction.itemPurchaseIteration !== 'first') {
        return Maybe.empty();
    }
    const successAt = transaction.successAt;
    const age = datetime.diff(successAt, getNow(successAt));
    const refundTime = transaction.purchasedItem.refundPeriod.clone().subtract(age);
    if (refundTime.asMilliseconds() <= 0) {
        return Maybe.empty();
    }
    return Maybe.of(refundTime);
}
/**
 * Format the price of a purchasable item, with tax behavior.
 *
 * @param param0 Price and tax behavior to format.
 * @returns The formatted price with tax behavior.
 */
export function formatPrice({ price, hideTaxBehavior }) {
    const numeric = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: price.currency,
    }).format(price.amount.toNumber()); // ignore: no-raw-format
    if (hideTaxBehavior === true) {
        return `${numeric}`;
    }
    const tax = expr.switcher(price.taxBehavior, {
        disabled: () => '',
        exclusive: () => ' (excl. tax)',
        inclusive: () => ' (incl. tax)',
    });
    return `${numeric} ${tax}`;
}
